import redirectInterceptor from "@/interceptors/redirect_interceptor";
import { voyageModule } from "./voyage";
import router from "@/router";
import { voyageAuxEnginesModule } from "./aux_engines";
import { voyageFuelConsumptionDataModule } from "./fuel_consumption";
import { voyageWindDataModule } from "./wind_data";
import { voyageRelativeWindDataModule } from "./relative_wind_data";
import { voyageSpeedDataModule } from "./speed_data";
import { weatherDataModule } from "./weather_data";
import { vesselPositionModule } from "./position";
import { overconsumptionModule } from "./overconsumption";
import { foulingModule } from "./fouling";

const getDefaultState = () => {
  return {
    voyageLegs: [],
    selectedLeg: null,
  };
};

const state = getDefaultState();

const getters = {};

const actions = {
  async fetchVoyageLegs({ commit }, name) {
    const url = `${localStorage.getItem("basicUrl")}/vesselperformance/vessel/${name}/allVoyageLegs/`;
    const response = await redirectInterceptor.get(url, {
      headers: {
        Authorization: localStorage.getItem("quad_token")
      }
    });

    if (response.data.success) {
      commit("SET_VOYAGE_LEGS", response.data.data);
    } else {
      if (response.data.msg === "rdr") {
        router.push("/login");
      }
      commit("SET_VOYAGE_LEGS", []);
    }
  },
  //const startDate = state.selectedLeg.startDate
  async fetchVoyageData({ dispatch }, name) {
    const startDate = state.selectedLeg.startDate.substring(0, 19).replace("T", " ");
    const stopDate = state.selectedLeg.stopDate.substring(0, 19).replace("T", " ");
    const dateRangePayload = { name: name, startDate: startDate, stopDate: stopDate };

    const singleDatePayload = { name: name, date: stopDate };

    const requests = [
      dispatch("voyageAuxEnginesModule/fetchVoyageAuxRHP", dateRangePayload),
      dispatch("voyageFuelConsumptionDataModule/fetchVoyageFuels", dateRangePayload),
      dispatch("weatherDataModule/fetchWeatherData", dateRangePayload),
      dispatch("voyageWindDataModule/fetchVoyageWindData", dateRangePayload),
      dispatch("voyageSpeedDataModule/fetchVoyageSpeedData", dateRangePayload),
      dispatch("voyageModule/fetchVoyageData", singleDatePayload),
      dispatch("voyageModule/fetchVoyageBunkerData", singleDatePayload),
      dispatch("voyageModule/fetchVoyageAverageSpeedData", singleDatePayload),
      dispatch("sensorIssues/fetchSensorIssues", dateRangePayload, { root: true }),
      dispatch("vesselPositionModule/fetchVoyageVesselPositionData", dateRangePayload),
      dispatch("overconsumptionModule/fetchOverconsumptionData", dateRangePayload),
      dispatch("foulingModule/fetchFoulingData", singleDatePayload)
    ];
    await Promise.all(requests);

  }
};

const mutations = {
  SET_VOYAGE_LEGS: (state, data) => (state.voyageLegs = data),
  SET_SELECTED_LEG: (state, data) => (state.selectedLeg = data)
};

export const vesselInformationModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    voyageModule: voyageModule,
    voyageAuxEnginesModule: voyageAuxEnginesModule,
    voyageFuelConsumptionDataModule: voyageFuelConsumptionDataModule,
    voyageWindDataModule: voyageWindDataModule,
    voyageSpeedDataModule: voyageSpeedDataModule,
    weatherDataModule: weatherDataModule,
    vesselPositionModule: vesselPositionModule,
    overconsumptionModule: overconsumptionModule,
    foulingModule: foulingModule,
    voyageRelativeWindDataModule: voyageRelativeWindDataModule

  }
};
